import { render, staticRenderFns } from "./product-detail-route.vue?vue&type=template&id=5f42f142&scoped=true&"
import script from "./product-detail-route.vue?vue&type=script&lang=js&"
export * from "./product-detail-route.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-route.vue?vue&type=style&index=0&id=5f42f142&prod&lang=scss&module=true&"
import style1 from "./product-detail-route.vue?vue&type=style&index=1&id=5f42f142&prod&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5f42f142",
  null
  
)

export default component.exports